import React from "react";
import { EntityProfileType } from "@common/types/entity";
import { entityTypeV2Labels } from "@common/constants/entity";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./LegalTypeFilter.module.scss";

const legalTypes = Object.values(EntityProfileType).filter(
    (v) => v !== EntityProfileType.NO_LEGAL_ENTITY,
);

const legalTypesSet: ReadonlySet<string> = new Set(legalTypes);

const options: FilterMultiselectOption[] = legalTypes.map((v) => ({
    value: v,
    label: entityTypeV2Labels[v],
    searchableLabel: entityTypeV2Labels[v],
}));

export const LegalTypeFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.legalTypes ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const filtered = val.filter((v): v is EntityProfileType =>
                        legalTypesSet.has(String(v)),
                    );
                    onChange({
                        legalTypes: filtered.length > 0 ? filtered : undefined,
                    });
                }}
                name="legalTypes"
                onBlur={noop}
            />
        </div>
    );
};
